import { useContext } from "react";
import { AppContext } from "../App";
import { MdLogout, MdOutlineRefresh } from "react-icons/md";
import { setCookie } from "../Helpers";
import logo from "../assets/logo_icon.png";
import { formatAdminRole } from "../accessControl";

export default function TopBar(props) {
  const appContext = useContext(AppContext);
  const currentUser = appContext.currentUserData;
  const displayName = currentUser?.fullname || currentUser?.name || "Admin team";
  const roleLabel = formatAdminRole(currentUser?.role);
  const avatarInitial = String(displayName || "A").charAt(0).toUpperCase();

  async function logOut() {
    appContext.setShowOverlayLoader(true);
    setCookie("adminId", "", -10000000);
    setCookie("adminToken", "", -10000000);

    appContext.refresh();
    appContext.setShowOverlayLoader(false);
  }

  return (
    <div className="TopBar">
      <div className="body">
        <div className="topbar-brand">
          <div className="topbar-brand-mark">
            <img src={logo} width={34} className="align-self-center" alt="Bob Admin" />
          </div>
          
        </div>

        <div className="topbar-actions">
          <div className="topbar-user-card d-none d-md-flex">
            <div className="topbar-user-avatar" aria-hidden="true">
              {avatarInitial}
            </div>
            <div className="topbar-user-copy">
              <strong>{displayName}</strong>
              <span>{roleLabel}</span>
            </div>
          </div>
          <button className="topbar-icon-btn" onClick={appContext.refresh} aria-label="Refresh">
            <MdOutlineRefresh className="mSymbol" />
          </button>

          <button className="topbar-icon-btn topbar-icon-btn-danger" onClick={logOut} aria-label="Logout">
            <MdLogout className="mSymbol" />
          </button>
        </div>
      </div>
    </div>
  );
}
